module.exports = __webpack_public_path__ + "img/Logo-bw.700ac770.png";